import React from "react";
import {Typography, useTheme} from "@mui/material";
import {DataGrid} from "@mui/x-data-grid";
import {formatCurrency} from "../utils/formatters";

export const WaterfallTable = ({data, loading}) => {
    const theme = useTheme();
    const dims = theme.dimensions;

    const common = {sortable: true, disableColumnMenu: true, headerClassName: 'table-header'};
    const colDefs = [
        {...common, type: 'text', width: 350, headerAlign: 'left', field: 'account_name', headerName: 'Account'},
        {...common, type: 'number', width: 140, headerAlign: 'right', field: 'gross_price', headerName: 'Gross Price', valueFormatter: v => formatCurrency(v)},
        {...common, type: 'number', width: 140, headerAlign: 'right', field: 'unit_discount_amount', headerName: 'Unit Discount', valueFormatter: v => formatCurrency(v)},
        {...common, type: 'number', width: 140, headerAlign: 'right', field: 'net_price', headerName: 'Net Price', valueFormatter: v => formatCurrency(v)},
        {...common, type: 'number', width: 140, headerAlign: 'right', field: 'unit_vcogs', headerName: 'Unit VCOGS', valueFormatter: v => formatCurrency(v)},
        {...common, type: 'number', width: 165, headerAlign: 'right', field: 'unit_variable_margin', headerName: 'Unit Variable Margin', valueFormatter: v => formatCurrency(v)},
        {...common, type: 'number', width: 130, headerAlign: 'right', field: 'unit_freight_costs', headerName: 'Unit Freight', valueFormatter: v => formatCurrency(v)},
        {...common, type: 'number', width: 160, headerAlign: 'right', field: 'unit_commission_costs', headerName: 'Unit Commission', valueFormatter: v => formatCurrency(v)},
        {...common, type: 'number', width: 180, headerAlign: 'right', field: 'unit_pocket_price_margin', headerName: 'Unit Pocket Margin', valueFormatter: v => formatCurrency(v)}
    ];

    const determineRowClass = (params) => {
        return params.indexRelativeToCurrentPage % 2 === 1 ? 'table-row-odd' : 'table-row-even';
    };

    return (
        <div style={{marginTop: 30, width: dims.contentWidth}}>
            <Typography variant="h6" color="inherit" style={{marginBottom: 10}}>Margin Waterfall by Account</Typography>
            <DataGrid columns={colDefs} rows={data} loading={loading}
                      columnHeaderHeight={30} rowHeight={30} autoHeight
                      getRowClassName={params => determineRowClass(params)}
                      initialState={{pagination: {paginationModel: {pageSize: 10}}}} pageSizeOptions={[10, 25]}
                      disableRowSelectionOnClick disableMultipleRowSelection disableColumnResize/>
        </div>
    );
};